<template>
    <span>
        <span v-if="documentType == 'BankOrder'">{{translate('jobDocumentType.bankOrder')}}</span>
        <span v-else-if="documentType == 'Contract'">{{translate('jobDocumentType.contract')}}</span>
        <span v-else-if="documentType == 'General'">{{translate('jobDocumentType.general')}}</span>
        <i v-else class="text-muted">{{translate('jobDocumentType.unknown')}}</i>
    </span>
</template>
<script>
export default {
    props: {
        documentType: {
            type: String,
            required: true
        }
    }
}
</script>